const getContentAvailability = (formatTypes, proveedorCode) => {
  return formatTypes?.reduce((prev, type) => {
    let label = '';
    switch (type) {
      case 'free':
        label = 'gratuito';
        break;
      case 'ppe':
        label = 'alquiler';
        break;
      case 'susc':
        label = `por suscripcion${
          proveedorCode === 'amco' ? '' : ` ${proveedorCode}`
        }`;
        break;
      case 'est':
        label = 'compra';
        break;
      default:
        break;
    }
    if (label === '') return prev;
    return [...prev, label];
  }, []);
};

export const getContentAvailabilityByButton = button => {
  const { producttype, oneoffertype } = button;

  switch (oneoffertype) {
    case 'download_buy':
      const label = 'comprar';
      switch (producttype) {
        case 'CV_STDBUY':
          return `${label} pelicula`;
        case 'CV_EPISODEBUY':
          return `${label} episodio`;
        case 'CV_SEASONBUY':
          return `${label} temporada completa`;
        default:
          return label;
      }
    case 'download_rent':
      return 'alquiler';
    case 'subscrition':
      return `por suscripcion${
        producttype === 'CV_MENSUAL' || producttype === 'CV_ANUAL'
          ? ''
          : ` ${producttype}`
      }`;
    default:
      break;
  }
};

export default getContentAvailability;
